import React, { useEffect, useRef } from 'react'
import styles from './Cursor.module.scss'
import gsap from 'gsap';

const Cursor = ({ color }) => {

    const circle = useRef(null);
    useEffect(() => {
        const moveCircle = (e) => {
            gsap.to(circle.current, 0.3, {
                css: {
                    left: e.pageX,
                    top: e.pageY,
                },
            });
        }
        window.addEventListener('mousemove', moveCircle)
    }, [])

    return (
        <div className={styles.circle} ref={circle} >
            <svg viewBox="0 0 150 150" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                <path fill={color} d="M75,100 C88.8071187,100 100,88.8071187 100,75 C100,61.1928813 88.8071187,50 75,50 C61.1928813,50 50,61.1928813 50,75 C50,88.8071187 61.1928813,100 75,100 Z"></path>
            </svg>
        </div>
    )
}

export default Cursor